import { AuthUserType, Permission } from "../types";

// NOTE: if permissions is undefined, it will return false
// if it's empty array, it will return true
export function hasPermissions(user: AuthUserType, permissions: Permission[] | undefined) {
  const userPermissions = user?.permissions.map(({ permission }) => permission)
  return permissions?.every((permission) => userPermissions?.includes(permission));
}
